import FeatureKeys from "./FeatureKeys";

export interface FeatureUpgradeCopy {
  title: string;
  message: string;
}

/**
 * Per-feature "why upgrade" copy, shared by every upgrade surface (modal, card,
 * banner) so the three never drift. Only features with plan-specific messaging
 * get an entry here — every other `FeatureKey` falls back to the generic
 * `FEATURE_GATE_*` strings in `StringConstants`, by design: naming a plan tier
 * that isn't actually correct for a feature is worse than a generic sentence.
 */
const FEATURE_UPGRADE_COPY: Record<string, FeatureUpgradeCopy> = {
  [FeatureKeys.ENVELOPE_MULTI_DOCUMENT]: {
    title: "Send multiple documents",
    message:
      "Uploading more than one document in a single envelope is included in higher plans. Upgrade to bundle multiple files into one signing request.",
  },
  [FeatureKeys.CONTACT_CSV_IMPORT]: {
    title: "Bulk upload contacts",
    message:
      "Importing contacts from a CSV file is included in higher plans. Upgrade to add hundreds of contacts at once instead of one by one.",
  },
  [FeatureKeys.BRANDING_CUSTOM]: {
    title: "Custom branding",
    message:
      "Applying your company logo, colors, and sender details to outgoing emails is included in higher plans. Upgrade to deliver a fully branded signing experience.",
  },
};

export default FEATURE_UPGRADE_COPY;
